import React, { useContext, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Button } from '@rneui/themed';
import PropTypes from 'prop-types';
import CdnImageBackground from '../common/CdnImageBackground';
import { StyledWebView } from '../common/StyledWebView';
import { H1, H5 } from '../text';
import LayoutContext from '../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'ministry';

const Ministry = ({
    ctaHeading,
    ctaLink,
    ctaLinkText,
    ctaOptionalBar,
    enableImageOverlay = false,
    featuredImage,
    followContentLink,
    ministryName,
    ministryDescription,
    nodeTypeAlias = 'Ministry',
    width,
    hardWidth
}) => {
    const { layout } = useContext(LayoutContext);
    const [imageDimensions, setImageDimensions] = useState();

    return (
        <View
            style={{ marginBottom: layout.styleGuide.componentSeparator }}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
        >
            <CdnImageBackground
                alt={ministryName}
                imageDimensions={imageDimensions}
                setImageDimensions={setImageDimensions}
                enableOverlay={enableImageOverlay}
                uri={featuredImage?.cdnImagePath}
                width={hardWidth}
            >
                {ctaOptionalBar && (
                    <View style={StyleSheet.flatten(Styles.ctaOptionalBar, { paddingHorizontal: layout.styleGuide.spacer2 })}>
                        <View style={{ flex: 1, marginTop: layout.styleGuide.spacer2 }}>
                            <H5 style={{ color: '#fff' }} text={ctaHeading} />
                        </View>
                        <Button
                            icon={{
                                color: '#fff',
                                name: 'chevron-circle-right',
                                type: 'font-awesome-5',
                                size: layout.device.isMobile ? 18 : 16
                            }}
                            size='sm'
                            iconContainerStyle={{ padding: 4 }}
                            iconRight={true}
                            onPress={async () => await followContentLink(ctaLink.isExternal, ctaLink.internalKey, ctaLink.externalUrl)}
                            title={<H5 style={{ color: '#fff' }} text={ctaLinkText} />}
                            titleStyle={Styles.ctaButtonTitle}
                            type='clear'
                        />
                    </View>
                )}
                <View style={Styles.nameContainer}>
                    <H1 style={{ color: '#fff', marginLeft: layout.styleGuide.spacer1 }} text={ministryName} />
                </View>
            </CdnImageBackground>

            {!!ministryDescription && (
                <View style={{ marginBottom: layout.styleGuide.spacer2, marginHorizontal: layout.styleGuide.spacer1, marginTop: Math.floor(layout.styleGuide.spacer2 * 2) }}>
                    <StyledWebView html={ministryDescription} nodeId={STYLED_WEB_VIEW_ID} width={width} />
                </View>
            )}
        </View>
    );
};

const Styles = StyleSheet.create({
    ctaButtonTitle: {
        color: '#fff',
        fontFamily: 'GothamMedium',
        fontSize: '16pt',
        lineHeight: '18pt',
        textAlign: 'left'
    },
    ctaOptionalBar: {
        alignItems: 'center',
        backgroundColor: 'rgba(21, 61, 110, 0.5)',
        flex: 1,
        flexDirection: 'row',
        height: 75,
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0
    },
    nameContainer: {
        alignItems: 'center',
        bottom: 0,
        flexDirection: 'row',
        position: 'absolute'
    }
});

Ministry.propTypes = {
    ctaOptionalBar: PropTypes.bool,
    ctaHeading: PropTypes.string,
    ctaLink: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string,
        isExternal: PropTypes.bool
    }),
    ctaLinkText: PropTypes.string,
    featuredImageSrc: PropTypes.shape({
        cdnImagePath: PropTypes.string
    }),
    ministryDescription: PropTypes.string,
    ministryName: PropTypes.string
};

export default Ministry;
